module.exports = __webpack_public_path__ + "static/media/avive_aed_unaccepted_active.22cd7012.svg";